import qs from "qs";
import request from "@/utils/request";

export function myDownloadList(params) {
  return request({
    url: `/assets/get/download/list`,
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params: params,
  });
}

export function myAssetsList(params) {
  return request({
    url: `/assets/get/list/page`,
    method: "get",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params: params,
  });
}

export function deleteMyAssets(params) {
  return request({
    url: `/assets/v1/delete`,
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params,
  });
}

export function queryWorkList(params) {
  return request({
    url: `/work/order/v1/query/all/list`,
    method: "get",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params: params,
  });
}

// 查询所有工单的类型
export function queryAllWorkType() {
  return request({
    url: `/work/order/v1/query/types`,
    method: "get",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
  });
}

// 创建工单 /api/cgsj_app/work/order/v1/add
export function createWork(data) {
  return request({
    url: `/work/order/v1/add`,
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data,
  });
}

// 查询工单所有回复
export function queryReplyWork(params) {
  return request({
    url: `/work/order/v1/reply/list`,
    method: "get",
    params: params,
  });
}
// 回复
export function createApply(data) {
  return request({
    url: `/work/order/v1/add/reply`,
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data,
  });
}

// 删除工单
export function deleteReply(params) {
  return request({
    url: `/work/order/v1/reply/del`,
    method: "post",
    params: params,
  });
}

// 删除
export function deleteWordOrder(params) {
  return request({
    url: `/work/order/v1/del`,
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params: params,
  });
}

// 按条件查询资产
export function queryAssetsByCondition(data) {
  return request({
     url: "/assets/get/list/conditionTitle",
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data,
  });
}

// 购物车
export function getCart(params) {
  return request({
    url: `/shopping/cart/query`,
    method: "get",
    params: params,
  });
}

// 添加资产到购物车
export function addCart(params) {
  return request({
    url: `/shopping/cart/add`,
    method: "get",
    params: params,
  });
}

// 删除
export function deleteCart(params) {
  return request({
    url: `/shopping/cart/delete`,
    method: "get",
    params: params,
  });
}

// 查詢詳情
export function getDetail(params) {
  return request({
    url: `/assets/v1/get`,
    method: "get",
    params: params,
  });
}

// 根据id 查label
export function getLabelById(labelId) {
  return request({
    url: `/label/get/${labelId}`,
    method: "get",
  });
}

/* 根据ID获取分类详情 */
export function classIdApi(categoryId) {
  return request({
    url: `/query/menu/category`,
    method: "get",
    params: {
      categoryId,
    },
  });
}

/* 根据ID获取行业 */
export function industryIdApi(industryId) {
  return request({
    url: `/industry/get/${industryId}`,
    method: "get",
  });
}

export function createContent(data) {
  return request({
    url: "/remarks/v1/add/new",
    method: "post",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data,
  });
}
// 结算
export function settlementCartApi(params) {
  return request({
    url: `/shopping/cart/settlement`,
    method: "get",
    params: params,
  });
}

export function resourceDetailApi(id) {
  return request({
    url: "/assets/v1/get/by/auth",
    method: "get",
    params: { id },
  });
}

export function downLoadApi(params) {
  return request({
    url: `/common/download/file`,
    method: "post",
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params,
  });
}
export function downLoadUrlApi(params) {
  return request({
    url: `/common/get/download/url`,
    method: "get",
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    // responseType: "arraybuffer",
    // headers: { "Content-Type": "application/json;charset=UTF-8" },
    params,
  });
}

export function queryCommentList(params) {
  return request({
    url: `/remarks/v1/query/source/rem`,
    method: "get",
    params: params,
  });
}

export function AuthorComment(params) {
  return request({
    url: `/remarks/v1/auth/reply`,
    method: "post",
    params: params,
  });
}

export function getCommentConfig() {
  return request({
    url: `/sys/switch/get`,
    method: "get",
    params: { switchId: 100 },
  });
}
export function wxQrCode(params) {
  return request({
    url: `/pay/wxQrCode`,
    method: "post",
    params: params,
  });
}
export function zfbQrCode(params) {
  return request({
    url: `/pay/zfbQrCode`,
    method: "post",
    params: params,
  });
}
export function queryWxPayStatus(params) {
  return request({
    //url: `/pay/queryWxPayStatus`,
    url: '/pay/queryMemberWxPayStatus',
    method: "post",
    params: params,
  });
}
export function queryZfbPayStatus(params) {
  return request({
    url: `/pay/queryZfbPayStatus`,
    method: "post",
    params: params,
  });
}
export function queryUserInfo() {
  return request({
    url: `/shopping/user/info`,
    method: "get",
  });
}

export function priceChangeApi(params){
  return request({
    url: '/shopping/cart/ids',
    method: 'get',
    params
  })
}

export function getCartRestApi(params){
  return request({
    url: '/shopping/user/member/discount',
    method: 'get',
    params
  })
}